import { Button, Collapse, Form, Input } from 'antd'
import { useState } from 'react'
import { SuccessMessage } from './SuccessMessage'

const { Panel } = Collapse

function PasswordRecovery() {
  const [form] = Form.useForm()
  const [recoverySent, setRecoverySent] = useState(false)

  const handleSubmit = () => {
    setRecoverySent(true)
    form.resetFields()
  }

  return (
    <Collapse ghost accordion className="password-recovery">
      <Panel header="Забыли пароль?" key="recovery">
        <SuccessMessage message={ recoverySent && 'Инструкции по восстановлению отправлены на указанный e-mail' } />
        <Form
          form={form}
          name="password-recovery"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item
            label="Эл. Почта"
            name="email"
            rules={[
              { type: 'email', message: 'The input is not valid E-mail!' },
              { required: true, message: 'Введите адрес Вашей электронной почты' }
            ]}
          >
            <Input autoComplete="email" placeholder="example@domain.com" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Восстановить пароль
            </Button>
          </Form.Item>
        </Form>
      </Panel>
    </Collapse>
  )
}

export default PasswordRecovery
